export default __webpack_public_path__ + "static/media/Caitlin 9781408303559.8e655250.jpg";